import React from 'react';
import styled from 'styled-components';
import { goToTop } from '_helpers';
import { colors } from '_styles';
import { _ } from '_locales';
import HOC from '_HOC';

const Container = styled.div`
    width: 100%;
    max-width: 580px;
    padding: 45px 35px;
    box-sizing: border-box;
    margin: 0 auto;
    min-height: 350px;
`;

const Title = styled.h3`
    font-size: 20px;
    font-weight: 400;
    font-family: Roboto, sans-serif;
    color: #000;
    text-align: left;
`;

const Description = styled.h4`
    font-size: 16px;
    font-weight: 500;
    font-family: Roboto, sans-serif;
    color: #575757;
    line-height: 1.8em;
`;

const ContactUsBtn = styled.button`
  color: #fff;
  width: 160px;
  height: 39px;
  border: none;
  display: flex;
  font-size: 14px;
  padding: 20px 0;
  cursor: pointer;
  position: relative;
  border-radius: 8px;
  align-items: center;
  margin: 40px auto 15px;
  justify-content: center;
  background-color: ${colors.RC_ACTION};
`;

const ContactUs = ({ props }) => {
  const { location, history } = props;
  const { title, type } = location.state;

  return (
    <Container>
      <Description>{_('help.to_subscribe_to_recycle_coach_reminders')}</Description>
      <br />

      <Title>{_('help.not_receiving_email_reminders')}</Title>
      <Description>{_('help.if_you_are_subscribed_to_the_email_reminders_but_not_receiving_email_reminders')}</Description>
      <Description>{_('help.if_you_used_to_receive_collection_reminders_but_are_no_longer_receiving_them')}</Description>
      <br />

      <Title>{_('help.not_receiving_sms_or_phone_call_reminders')}</Title>
      <Description>{_('help.if_you_are_subscribed_to_recycle_coach_sms_or_phone_call_reminders')}</Description>
      <br />

      <ContactUsBtn onClick={() => [goToTop(), history.push('/help/form-page', {
        title, type, formDesc: 'none', description: _('help.please_describe_the_issue')
      })]}
      >
        {_('help.contact_us')}
      </ContactUsBtn>
    </Container>
  );
};

export default HOC(ContactUs);
